 // PC
    var agreeFlag = true;

    function checkBoxClick(dom) {

        if (document.getElementById("clauseCheck").checked) {
            agreeFlag = true

            $("#contactEmailFromSubmitBtn").addClass('submitActive');
            $("#contactEmailFromSubmitBtn").removeAttr('disabled');
        } else {
            agreeFlag = false;
            $("#contactEmailFromSubmitBtn").removeClass('submitActive');
            $("#contactEmailFromSubmitBtn").attr('disabled', 'disabled');
        }
    }

    function checkData(e) {
        if (!agreeFlag) {
            e.preventDefault();
            return false;
        }
    }
    // mobile
    var agreeFlag_mobile = true;

    function checkBoxClickMobile(dom) {

        if (document.getElementById("clauseCheck-mobile").checked) {
            agreeFlag_mobile = true

            $("#contactEmailFromSubmitBtn-mobile").addClass('submitActive-mobile');
            $("#contactEmailFromSubmitBtn-mobile").removeAttr('disabled');
        } else {
            agreeFlag_mobile = false;
            $("#contactEmailFromSubmitBtn-mobile").removeClass('submitActive-mobile');
            $("#contactEmailFromSubmitBtn-mobile").attr('disabled', 'disabled');
        }
    }

    function checkData(e) {
        if (!agreeFlag_mobile) {
            e.preventDefault();
            return false;
        }
    }

    // laptop
    var agreeFlag_laptop = true;

    function checkBoxClicklaptop(dom) {

        if (document.getElementById("clauseCheck-laptop").checked) {
            agreeFlag_laptop = true

            $("#contactEmailFromSubmitBtn-laptop").addClass('submitActive-laptop');
            $("#contactEmailFromSubmitBtn-laptop").removeAttr('disabled');
        } else {
            agreeFlag_laptop = false;
            $("#contactEmailFromSubmitBtn-laptop").removeClass('submitActive-laptop');
            $("#contactEmailFromSubmitBtn-laptop").attr('disabled', 'disabled');
        }
    }

    function checkData(e) {
        if (!agreeFlag_laptop) {
            e.preventDefault();
            return false;
        }
    }